import React from 'react';
import { Alert, Button } from 'react-bootstrap';

/**
 * Componente para mostrar errores de manera consistente
 */
const AlertError = ({ 
    message, 
    title = "Error", 
    variant = "danger",
    dismissible = true,
    onDismiss = null,
    showRetry = false,
    onRetry = null,
    className = "" 
}) => {
    return (
        <Alert 
            variant={variant} 
            dismissible={dismissible}
            onClose={onDismiss}
            className={`d-flex align-items-start ${className}`}
        >
            <div className="flex-grow-1">
                <div className="d-flex align-items-center mb-2">
                    <i className="fas fa-exclamation-triangle me-2 fs-5"></i>
                    <Alert.Heading className="mb-0 h5">{title}</Alert.Heading>
                </div>
                
                <div className="mb-0">
                    {/* ✅ RENDERIZAR MENSAJE CON SALTOS DE LÍNEA */}
                    {message.split('\n').map((line, index) => (
                        <div key={index}>
                            {line.trim()}
                            {index < message.split('\n').length - 1 && <br />}
                        </div>
                    ))}
                </div>
                
                {showRetry && onRetry && (
                    <div className="mt-3">
                        <Button 
                            variant="outline-danger" 
                            size="sm" 
                            onClick={onRetry}
                        >
                            <i className="fas fa-redo me-1"></i>
                            Reintentar
                        </Button>
                    </div>
                )}
            </div>
        </Alert>
    );
};

// ✅ COMPONENTES ESPECÍFICOS PRE-CONFIGURADOS
export const APIError = ({ message, onRetry, onDismiss }) => (
    <AlertError
        title="Error de conexión"
        message={message}
        variant="danger"
        showRetry={true}
        onRetry={onRetry}
        onDismiss={onDismiss}
    />
);

export const ValidationError = ({ message, onDismiss }) => (
    <AlertError
        title="Error de validación"
        message={message}
        variant="warning"
        showRetry={false}
        onDismiss={onDismiss}
    />
);

export const NetworkError = ({ onRetry, onDismiss }) => (
    <AlertError
        title="Error de red"
        message="No se pudo conectar con el servidor. Verifica tu conexión a internet e intenta nuevamente."
        variant="danger"
        showRetry={true}
        onRetry={onRetry}
        onDismiss={onDismiss}
    />
);

export default AlertError;